import { requestGet } from '@/utils/request';

const api = {
    LIST: '/statistics/stat_performer_list'
};

export function statPerformerList(params) {
    return requestGet(api.LIST, params);
}
